import { FC } from 'react';
import './styles.css';
import { twMerge } from 'tailwind-merge';
import basicLoaderCircle from './styles';

interface LoaderCircleProps {
  classNameContainer?: string;
  className?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xl';
}

const LoaderCircle: FC<LoaderCircleProps> = ({
  classNameContainer,
  className,
  size = 'medium',
}) => {
  return (
    <div
      className={twMerge(
        basicLoaderCircle.styleLoaderCircleContainer(),
        classNameContainer
      )}
    >
      <span
        className={twMerge(
          basicLoaderCircle.styleLoaderCircle({ size }),
          className
        )}
      >
        <span
          className={twMerge(
            basicLoaderCircle.styleLoaderCircleInnerSpan({ size }),
            className
          )}
        />

        <span
          className={twMerge(
            basicLoaderCircle.styleLoaderCircleMiddleSpan({ size }),
            className
          )}
        ></span>
      </span>
    </div>
  );
};

export default LoaderCircle;
